import React from 'react';
import classNames from 'classnames';
import { useBridgeService } from '../../hooks/useBridgeService';
import { getNetworkIcon } from './NetworkRenderer.utils';
export const NetworkRenderer = ({ chainId, className, }) => {
    const bridgeService = useBridgeService();
    if (!bridgeService || !chainId) {
        return null;
    }
    const networkConfig = bridgeService.getNetworkConfig(chainId);
    if (!networkConfig) {
        return null;
    }
    return (React.createElement("div", { className: classNames('flex items-center gap-2', className) },
        React.createElement("img", { className: "w-5 h-5 rounded-full", src: getNetworkIcon(chainId), alt: networkConfig.name }),
        React.createElement("span", null, networkConfig.name)));
};
